export const billingConfiguration = {
  header: {
    title: "Konfiguracja fakturowania",
    description:
      "Zarządzanie wystawcami faktur na koncie i przypisanie każdej oferty do właściwego wystawcy.",
  },

  intro: {
    lead:
      "<strong>Wystawca faktur</strong> to podmiot podatkowy, który fakturuje gości. Można mieć kilku wystawców i wybrać, który fakturuje daną ofertę.",
    feats: {
      fiscalData: {
        label: "Własne dane podatkowe",
        tip: "Nazwa prawna, NIF/CIF i adres podatkowy widoczne na fakturze.",
      },
      series: {
        label: "Niezależne serie",
        tip: "Każdy wystawca prowadzi własną serię i numerację (także dla faktur korygujących), bez mieszania.",
      },
      verifactu: {
        label: "VeriFactu dla każdego wystawcy",
        tip: "Każdy wystawca spełnia wymogi VeriFactu (podpis i rejestracja w AEAT) osobno, zgodnie ze swoją konfiguracją podatkową.",
      },
      assignment: {
        label: "Przypisanie do oferty",
        tip: "Proszę powiązać każdą ofertę z wystawcą. Nieprzypisane korzystają z wystawcy głównego.",
      },
    },
    foot: "Przy wystawianiu używany jest wystawca przypisany do oferty z danej rezerwacji (przy check-oucie lub gdy gość poprosi o fakturę agenta AI).",
  },

  issuers: {
    card: {
      title: "Wystawcy faktur",
      subtitle: "Można utworzyć wielu wystawców i przypisać do nich swoje oferty.",
    },
    searchPlaceholder: "Szukaj wystawcy po nazwie lub NIF…",
    newButton: "Nowy wystawca",
    noName: "Bez nazwy",
    defaultBadge: "Główny",
    listingsCount: "Ofert: {count}",
    empty: {
      noMatch: "Żaden wystawca nie pasuje do wyszukiwania.",
      none: "Brak wystawców. Pierwszego można utworzyć przyciskiem „Nowy wystawca”.",
    },
  },

  assign: {
    card: {
      title: "Przypisanie ofert",
      subtitle:
        "Proszę wybrać, który wystawca fakturuje daną ofertę. Oferta może mieć tylko jednego wystawcę, a nieprzypisane korzystają z głównego.",
    },
    searchPlaceholder: "Szukaj oferty…",
    filter: {
      all: "Wszystkie",
      unassigned: "Bez przypisania",
    },
    issuerFallback: "Wystawca #{id}",
    principalSuffix: " (główny)",
    unassignedOption: "· Bez przypisania (główny)",
    empty: {
      noMatch: "Żadna oferta nie pasuje do filtra.",
      none: "Brak ofert.",
    },
    count: "{shown} z {total} ofert",
  },

  drawer: {
    editTitle: "Edytuj wystawcę",
    newTitle: "Nowy wystawca",
    subtitle: "Dane podatkowe wystawcy faktur",
    closeAria: "Zamknij",
    footer: {
      isDefault: "To wystawca główny",
      setDefault: "Ustaw jako głównego",
      delete: "Usuń",
      cancel: "Anuluj",
      saving: "Zapisywanie...",
      save: "Zapisz wystawcę",
    },
  },

  company: {
    title: "Dane firmy",
    subtitle: "Informacje podatkowe obiektu",
    country: {
      label: "Kraj rozliczenia",
      hint: "Proszę wybrać kraj podatkowy właściwy dla tej konfiguracji.",
    },
    personType: {
      label: "Typ podmiotu",
      company: "Osoba prawna (firma)",
      individual: "Osoba fizyczna (działalność gospodarcza)",
    },
    legalName: {
      label: "Nazwa / Nazwa prawna",
      placeholderCompany: "np. INNDEV S.L.",
      placeholderIndividual: "np. María García",
      hint: "Nazwa podatkowa firmy lub osoby fizycznej",
    },
    co: {
      regime: {
        label: "Reżim DIAN",
        common: "Reżim wspólny",
        simplified: "Reżim uproszczony",
        hint: "Wymagane do fakturowania elektronicznego DIAN",
      },
      municipality: {
        label: "Gmina DIAN",
        hint: "Kod DIVIPOLA gminy, wymagany przez DIAN.",
        selected: "Wybrano: {code}",
      },
      responsibilities: {
        label: "Obowiązki podatkowe",
        placeholder: "np. O-13, R-99-PN",
        hint: "Kody rozdzielone przecinkami. Najczęstszy: <strong>O-13</strong>",
      },
    },
    mx: {
      regime: {
        label: "Reżim podatkowy (SAT)",
        placeholder: "np. 601",
        hint: "Kod reżimu podatkowego SAT",
      },
      zip: {
        label: "Podatkowy kod pocztowy (SAT)",
        placeholder: "np. 06600",
        hint: "Podatkowy kod pocztowy SAT",
      },
    },
  },

  address: {
    title: "Adres podatkowy",
    subtitle: "Adres widoczny na fakturach",
    street: {
      label: "Ulica i numer",
    },
    city: {
      label: "Miasto",
      hint: "Miasto i kod pocztowy",
    },
    email: {
      label: "E-mail do faktur",
      placeholder: "faktury@mojobiekt.com",
    },
    phone: {
      label: "Telefon",
    },
    ph: {
      ES: {
        street: "np. Gran Vía 42, piętro 3",
        city: "Madryt",
        zip: "28001",
        regionLabel: "Prowincja",
        region: "Madryt",
        phone: "+34 123 456 789",
      },
      CO: {
        street: "np. Calle 13 No. 10-25",
        city: "Bogota",
        zip: "110111",
        regionLabel: "Departament",
        region: "Cundinamarca",
        phone: "+57 601 234 5678",
      },
      MX: {
        street: "np. Av. Insurgentes Sur 1234",
        city: "Meksyk",
        zip: "06600",
        regionLabel: "Stan",
        region: "CDMX",
        phone: "+52 55 1234 5678",
      },
    },
  },

  bank: {
    title: "Konto do wpłat",
    subtitle: "Gdzie wpływają pieniądze przy płatności przelewem",
    iban: {
      label: "Numer konta (IBAN)",
      placeholder: "PL61 1090 1014 0000 0712 1981 2874",
      hint: "Pojawia się na fakturze tylko wtedy, gdy formą płatności jest przelew.",
      error: "Numer konta (IBAN) jest nieprawidłowy.",
    },
    bic: {
      label: "BIC / SWIFT",
      placeholder: "WBKPPLPP",
      hint: "Opcjonalnie. Potrzebny przy wpłatach spoza obszaru SEPA.",
    },
    holder: {
      label: "Właściciel konta",
      placeholder: "Zostaw puste, jeśli zgadza się z nazwą firmy",
      hint: "Tylko jeśli konto jest na inne nazwisko niż firma.",
    },
  },

  invoice: {
    title: "Konfiguracja faktur",
    subtitle: "Format, waluta i numeracja dokumentów",
    currency: {
      label: "Waluta domyślna",
      hint: "Waluta, w której będą wystawiane faktury",
    },
    taxRate: {
      label: "Domyślny IVA %",
      hintCO: "Ogólny IVA w Kolumbii: <strong>19%</strong>",
      hintMX: "Ogólny IVA w Meksyku: <strong>16%</strong>",
      hintES: "Obniżony IVA dla hotelarstwa w Hiszpanii: <strong>10%</strong>, ogólny: <strong>21%</strong>",
    },
    type: {
      label: "Typ faktury",
      detailed: {
        label: "Szczegółowa",
        desc: "Każda usługa w osobnym wierszu",
      },
      simplified: {
        label: "Uproszczona",
        desc: "Paragon lub faktura ze zbiorczymi pozycjami",
      },
    },
    numbering: {
      label: "Numeracja dokumentów",
      example: "np. {value}",
      invoices: {
        title: "Faktury",
      },
      series: "Seria",
      optional: "(opcjonalnie)",
      optionalPlaceholder: "Opcjonalnie",
      digits: "Cyfry",
      nextNumber: "Następny numer",
      hintOptional: "Seria jest opcjonalna. Po pozostawieniu pustego pola faktura zostanie wystawiona z samym numerem kolejnym.",
      hintFormat: "Po ustawieniu serii system zbuduje kod w formacie SERIA-NUMER. Bez serii powstanie sam NUMER.",
      hintWarn: "Tę wartość należy ustawić przed wystawieniem pierwszej faktury z danej serii, aby zachować ciągłość numeracji podatkowej.",
      hintSandboxCO: "W trybie sandbox należy użyć <strong>SETP</strong>, a w produkcji wartość musi odpowiadać rezolucji DIAN.",
    },
    creditNotes: {
      title: "Faktury korygujące",
      badge: "Anulowania / korekty",
      hint: "Używane przy następnej korekcie lub anulowaniu.",
    },
    footer: {
      label: "Domyślna stopka",
      hint: "Tekst, który pojawi się na dole wszystkich faktur",
      phES: "np. Transakcja objęta obniżonym IVA dla hotelarstwa zgodnie z art. 91 ustawy o IVA",
      phCO: "np. Rezolucja DIAN nr 000123 z 01-01-2025. Zakresy od 1 do 5000000",
      phMX: "np. CFDI wystawiona zgodnie z wymogami art. 29-A CFF",
    },
  },

  advanced: {
    title: "Opcje zaawansowane",
    subtitle: "Dodatkowe ustawienia wysyłki",
    attachPdf: {
      label: "Załącz PDF",
      text: "Dołącz dokument PDF obok linku do pobrania",
    },
  },

  loading: {
    default: "Wczytywanie...",
    config: "Wczytywanie konfiguracji...",
    profiles: "Wczytywanie wystawców...",
    saving: "Zapisywanie konfiguracji...",
  },

  countries: {
    ES: "Hiszpania",
    CO: "Kolumbia",
    MX: "Meksyk",
  },

  currencies: {
    EUR: "Euro",
    COP: "Peso kolumbijskie",
    USD: "Dolar amerykański",
    MXN: "Peso meksykańskie",
  },

  taxId: {
    labelFallback: "Identyfikator podatkowy",
    helpES: "NIF dla osób fizycznych, CIF dla firm, np. B12345678",
    helpCO: "NIT z cyfrą kontrolną, np. 9014514812 (10 cyfr)",
    helpMX: "RFC o długości 12 lub 13 znaków, np. XAXX010101000",
    helpFallback: "Identyfikator podatkowy",
  },

  validation: {
    taxIdES: "Nieprawidłowy format, np. B12345678",
    taxIdCO: "NIT musi mieć 9 lub 10 cyfr, np. 9014514812",
    taxIdMX: "Nieprawidłowy format RFC, np. XAXX010101000",
  },

  msg: {
    reassignError: "Nie udało się ponownie przypisać oferty.",
    defaultUpdated: "Wystawca główny zaktualizowany.",
    setDefaultError: "Nie udało się ustawić jako głównego.",
    deleteConfirm: "Usunąć tego wystawcę faktur?",
    deleted: "Wystawca usunięty.",
    deleteError: "Nie udało się usunąć wystawcy.",
    requiredFields: "Przed zapisaniem należy uzupełnić wszystkie wymagane pola.",
    fixTaxId: "Przed zapisaniem należy poprawić identyfikator podatkowy.",
    coRegimeRequired: "Reżim DIAN jest wymagany dla Kolumbii.",
    coMunicipalityRequired: "Gmina DIAN jest wymagana dla Kolumbii.",
    savedOk: "Wystawca zapisany pomyślnie.",
    saveError: "Błąd podczas zapisywania konfiguracji.",
  },

  misc: {
    thisIssuer: "tego wystawcy",
  },
};
